export default {
    '1_month_ago': "1 aydan az",
    '12_months_ago': "12 aydan az",
    '3_months_ago': "3 aydan az",
    '6_months_ago': "6 aydan az",
    above_1_month: "1 aydan çox",
    above_1_year: "1 ildən çox",
    above_2_months: "2 aydan çox",
    above_3_months: "3 aydan çox",
    above_6_months: "6 aydan çox",
    add_patients: "Xəstələr əlavə et",
    add_standard: "Standartları əlavə et",
    after_one_day: "Bir gündən sonra",
    after_service: "Xidmətdən sonra",
    agreement_to_get_notifications_in_max: "Maksimum bildirişləri almağa razılıq",
    all_statuses: "Bütün statuslar",
    amount_of_patients: "Xəstələrin sayı",
    april: "Aprel",
    are_you_sure_you_want_to_delete_mailing: "Siz həqiqətən bu göndərişi silmək istəyirsiniz?",
    august: "Avqust",
    birth_day: "Doğum günü",
    birth_month: "Doğum ayı",
    cannot_be_delivered: "Çatdırıla bilməz",
    channel: "Kanal",
    channels: "Kanallar",
    complex_status_changed: "Müalicə planında kompleksin statusu dəyişdirildi",
    create_mailing: "Göndəriş yarat",
    december: "Dekabr",
    do_not_send_at_night_time: "Gecə vaxtı göndərməyin (22:00 - 07:00)",
    does_not_contain: "Əhatə etmir",
    duplicate: "Kopyala",
    february: "Fevral",
    given_time: "Müəyyən edilmiş vaxt",
    has_future_visit: "Gələcək tarixlərdə viziti var",
    has_tags: "Etiketləri var",
    has_treatment_plan_with_status: "Müalicə planı statusu var",
    has_visit_with_status: "Statusla viziti var",
    immediately_after_creating: "Yaradıldıqdan dərhal sonra",
    january: "Yanvar",
    july: "İyul",
    june: "İyun",
    laboratory_order_status: "İş sifarişinin vəziyyəti",
    laboratory_order_status_changed: "Sifarişin statusunun dəyişdirilməsi",
    launch_mailing: "Göndərişi başlat",
    mailing: "Göndəriş",
    mailing_date: "Göndəriş tarixi",
    mailing_report: "Göndəriş hesabatı",
    mailings: "Göndərişlər",
    march: "Mart",
    marketing: "Marketinq",
    marketing_mailing: "Göndəriş",
    may: "May",
    no_push_token: "Token yoxdur",
    not_enough_balance: "Hesabda kifayət qədər vəsait yoxdur",
    november: "Noyabr",
    october: "Oktyabr",
    of_days: "gün",
    of_hours: "saat",
    passed_since_last_visit: "Son vizitdən keçib",
    payments_were: "Ödənişlər edildi",
    plan_status_changed: "Müalicə planının statusu dəyişdirildi",
    push_notification: "Push-bildiriş",
    push_notifications: "Push-bildirişlər",
    ready: "Hazırdır",
    retry: "Təkrar cəhd edin",
    same_day: "Eyni gün",
    save_filter: "Filteri yadda saxla",
    send_again: "Yenidən göndər",
    send_date: "Göndəriş tarixi",
    send_info: "Göndəriş məlumatı",
    sent_slash_error: "Göndərildi / Xəta",
    september: "Sentyabr",
    since_last_visit: "Son vizitdən sonra",
    sms_message: "SMS mesajı",
    stop_mailing: "Göndərişi dayandır",
    tags_for_marketing_mailing: "Məlumatın avtomatik çıxarılması üçün etiketlər:",
    task_title: "Tapşırıq adı",
    time: "Vaxt",
    token: "Token",
    tokens: "Tokenlər",
    too_many_attempts: "Çoxlu göndəriş cəhdləri",
    total_in_group: "Qrupda cəmi",
    treatment_plan_created: "Yeni müalicə planı yaradıldı",
    users_selected: "Seçilmiş istifadəçilər",
    visit_time_changed: "Vizitin vaxtı dəyişdirildi",
    wrong_credentials: "Göndəriş xidmətinin avtorizasiya məlumatları yanlışdır",
    wrong_phone_number: "Telefon nömrəsi yanlışdır"
}
